import {
  generalExtendedStatus
} from '../../../../end-user-order/end-user-order-list/end-user-order-view/end-user-order-debt-log/end-user-order-penalty-debt.model';

export enum CustomFormTypes {
  Pay = 'pay',
  Canceled = 'canceled'
}

export class CommentModel {
  commentTitle: string;
  initiator: string;
  timestamp: number;
  description: string;
}

export type InformationStatus = typeof generalExtendedStatus[keyof typeof generalExtendedStatus];

export class CustomPaymentInformationModel {
  title: string;
  iconClass: string;
  getCardsUrl: string;
  amount: number | string;
  currencyCode: string;
  status: InformationStatus;
  statusCancelTitle: string;
  comments: Array<CommentModel>;
}
